import { useLoaderData } from '@tanstack/react-router';
import type { DefinedPath } from './definePath';

// The DSL builds the route tree from `AnyRoute`, so neither the route id nor the loader's
// return type survives into TanStack's `useLoaderData({ from })`. Unlike `useRouteSearch`
// there is no schema to recover it from, so the caller names the type — keep it exported
// next to the loader.
export function useRouteLoaderData<T>(path: DefinedPath): T {
  return useLoaderData({ from: path.id } as never) as T;
}
